var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 104,
    viewBox: "0 0 87 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2055 101H12.5613C7.00462 101 2.5 96.5456 2.5 91.0508V12.9492C2.5 7.45443 7.00462 3 12.5613 3H56.8313M83.9969 29.8629V25.2151C83.9969 24.6873 83.7849 24.1812 83.4076 23.808L62.9544 3.58281C62.577 3.20964 62.0652 3 61.5315 3H56.8313M83.9969 29.8629V49.7614M83.9969 29.8629H58.8436C57.7322 29.8629 56.8313 28.9721 56.8313 27.8731V3M49.2853 63.6904L66.8926 81.1015M66.8926 81.1015L84.5 98.5127M66.8926 81.1015L84.5 63.6904M66.8926 81.1015L49.2853 98.5127",
    fill: "none",
    stroke: "#4F4F4D",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageError);
export default __webpack_public_path__ + "static/media/pageError.e96cfddc46a6e716dc4d9df8618389e1.svg";
export { ForwardRef as ReactComponent };